var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.381 7.3C7.59259 6.6985 8.01024 6.1913 8.55996 5.86822C9.10968 5.54514 9.75601 5.42704 10.3845 5.53484C11.0129 5.64264 11.5829 5.96937 11.9936 6.45718C12.4042 6.94498 12.6289 7.56237 12.628 8.2C12.628 10 9.928 10.9 9.928 10.9M10 14.5H10.009M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.09e8bcd32fad1797d8f2c65a62034e89.svg";
export { ForwardRef as ReactComponent };